export const persistMadUnicornId = (orderId, designId, MuId) => {
  sessionStorage.setItem(`mu-id:${orderId}:${designId}`, MuId);
};

export const getMadUnicornId = (orderId, designId) => {
  return sessionStorage.getItem(`mu-id:${orderId}:${designId}`);
};

export const clearMadUnicornId = (orderId, designId) => {
  sessionStorage.removeItem(`mu-id:${orderId}:${designId}`);
};

export const muTriesCount = {
  get: () => parseInt(sessionStorage.getItem("mu-count"), 0) || 0,
  set: (madUnicornCount) => sessionStorage.setItem("mu-count", madUnicornCount),
  remove: () => sessionStorage.setItem("mu-count", 0),
};
